const STATS = [
  { value: "130+", label: "Shows launched since 2015" },
  { value: "2014", label: "Podcasting since" },
  { value: "Founder-led", label: "Trusted by expert-led brands" },
  { value: "$100K+", label: "Sponsorship experience" },
]

export function CredibilityStrip() {
  return (
    <section className="border-y border-hairline bg-surface">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-4 py-10 sm:px-6 lg:grid-cols-4">
        {STATS.map((s) => (
          <div key={s.label} className="text-center">
            <div className="font-display text-2xl font-semibold text-ink-display sm:text-3xl">
              {s.value}
            </div>
            <p className="mt-1 text-sm text-ink-muted">{s.label}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
